// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\ndiv[data-v-03a3f69e] {\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
